import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import lodash from "./plugins/lodash";
import i18n from "./i18n";

import { Toast } from 'buefy'
import 'buefy/dist/buefy.css'

Vue.use(Toast)
Vue.config.productionTip = false;

Vue.prototype.$loggedIn = localStorage.getItem('MajaalToken');

new Vue({
  router,
  store,
  vuetify,
  lodash,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
